//Helper to get the right recharge prod data
// function getRechargeLineInfo(rechargeData, productId, variantId) {
//   productId = String(productId);
//   variantId = String(variantId);

//   //let charge = rechargeData.charges && rechargeData.charges[0];
//   var charge;
//   if ( rechargeData.charges )
//   {
//       for ( var i = 0; i < rechargeData.charges.length; i++ )
//       {
//           if ( rechargeData.charges[ i ].status == "QUEUED" )
//           {
//               charge = rechargeData.charges[ i ];
//               break;
//           }
//       }
//   }
//   let subLine = null, onetimeLine = null;

//   if (charge && charge.lines) {
//     subLine = charge.lines.find(
//       l => l.pid == productId && l.vid == variantId && l.type === 'SUBSCRIPTION'
//     );
//     onetimeLine = charge.lines.find(
//       l => l.pid == productId && l.vid == variantId && l.type === 'ONETIME'
//     );
//   }

//   // Find sub object for this product/variant (if exists)
//   let subObj = null;
//   if (rechargeData.subs && charge && rechargeData.subs[charge.at]) {
//     subObj = rechargeData.subs[charge.at].find(
//       s => s.pid == productId && s.vid == variantId
//     );
//   }

//   return {
//     aid: charge ? charge.aid : null,
//     ncs: charge ? charge.at : null,
//     sid: subLine ? subLine.sid : (subObj ? subObj.sid : null),
//     qty: subObj?.qty || subLine?.qty || 1,
//     freq: subObj?.sub?.frequncy || 4,
//     freqUnit: subObj?.sub?.frequencyUnit || 'week',
//     onetimeId: onetimeLine ? onetimeLine.sid : null
//   };
// }

function updatePLPCardQuantity(productId, variantId, newQty) 
{
  const productCard = document.querySelector(`.product-grid__product-card[data-product-id="${productId}"][data-variant-id="${variantId}"]`);
  if (!productCard) return;
  
  const qtyElement = productCard.querySelector('.pdp-autoship-qty-count');
  if (qtyElement) qtyElement.textContent = `${newQty} in Autoship`;
}

function showAutoshipModal({ product, variant, rechargeData }) 
{
  const modal   = document.getElementById('autoship-modal');
  const overlay = document.querySelector('.full-page-overlay');

  const info = getRechargeLineInfo(rechargeData, product.id, variant.id);
  modal.querySelector('.autoship-modal__next-date').textContent        = formatDate(info.ncs);
  modal.querySelector('.autoship-modal__repeat-interval').textContent = `${info.freq} weeks`;

  const qtyInput = modal.querySelector('.autoship-modal__qty-input');
  let debounceQtyTimer;
  const DEBOUNCE_DELAY = 300;

  function scheduleQtyUpdate(newQty) 
  {
    clearTimeout(debounceQtyTimer);
    debounceQtyTimer = setTimeout(() => 
    {
      window.ReallyModifySubscriptionQuantity(info.sid, newQty, (err) => 
      {
        if (err) {
        }
      });
    }, DEBOUNCE_DELAY);
  }

  qtyInput.value = info.qty;

  modal.querySelector('.autoship-modal__img').src                     = product.featured_image || product.image || '';
  modal.querySelector('.autoship-modal__prod-title > p').textContent  = product.title;
  modal.querySelector('.autoship-modal__prod-vendor').textContent     = product.vendor;

  // Pricing logic (pence conversion, fallbacks, badge)
  let basePrice     = parseFloat(variant.price);
  let compareAt     = parseFloat(variant.compare_at_price);
  let autoshipPrice = parseFloat(variant.autoship_price);

  if (basePrice && basePrice < 100)     basePrice     = Math.round(basePrice * 100);
  if (compareAt && compareAt < 100)     compareAt     = Math.round(compareAt * 100);
  if (autoshipPrice && autoshipPrice < 100) autoshipPrice = Math.round(autoshipPrice * 100);

  if (!basePrice || isNaN(basePrice))       basePrice     = 1000;
  if (!compareAt || isNaN(compareAt))       compareAt     = basePrice;
  if (!autoshipPrice || isNaN(autoshipPrice)) autoshipPrice = Math.round(basePrice * 0.95);

  modal.querySelector('.autoship-modal__price').textContent = `£${(autoshipPrice/100).toFixed(2)}`;

  let percentSaved;
  if (compareAt > basePrice) {
    percentSaved = Math.round((compareAt - basePrice)/compareAt * 100);
  } else {
    percentSaved = Math.round((basePrice - autoshipPrice)/basePrice * 100);
  }
  percentSaved += 5;

  const badge = modal.querySelector('.autoship-modal__badge span');
  if (badge) badge.textContent = `${percentSaved}% Saved with Autoship`;

  modal.classList.remove('hidden');
  document.querySelector('.autoship-overlay')?.classList.remove('hidden');

	var requestInProgress = false;
	var currQty           = 1;

  if (modal._autoCloseTimer) 
  {
    clearTimeout(modal._autoCloseTimer);
  }
  modal._autoCloseTimer = setTimeout(() => 
  {
    modal.classList.add('hidden');
    document.querySelector('.autoship-overlay')?.classList.add('hidden');
    if (overlay) 
    {
      overlay.style.opacity    = '0';
      overlay.style.visibility = 'hidden';
    }
    modal._autoCloseTimer = null;
  }, 90000);

  modal.querySelector('.autoship-modal__close').onclick = () => 
  {
    if (modal._autoCloseTimer) 
    {
      clearTimeout(modal._autoCloseTimer);
      modal._autoCloseTimer = null;
    }
    modal.classList.add('hidden');
    document.querySelector('.autoship-overlay')?.classList.add('hidden');
    if (overlay) 
    {
      overlay.style.opacity    = '0';
      overlay.style.visibility = 'hidden';
    }
  };

  modal.querySelector('.autoship-modal__qty-minus').onclick = function () 
  {
    let q = parseInt(qtyInput.value, 10);
    if (q <= 1) return;
		window.autoshipQuantityUpdates.push( { sid: info.sid, quantity: q - 1 } );
		qtyInput.value = q - 1;

		if ( !requestInProgress )
		{
			requestInProgress = true;
			handleModalQU( q - 1 );
		}
  };

	function handleModalQU( newQty )
	{
		window.ReallyModifySubscriptionQuantity(info.sid, newQty, (err, response) => 
		{
			if (!err)
			{
				var newestRequest    = getNewestRequest( "sid", info.sid );
				window._autoshipData = response;

				if ( newestRequest == null || newestRequest.quantity == newQty )
				{
					requestInProgress = false;
					updatePLPCardQuantity(product.id, variant.id, newQty);
					var aMProductCard = document.querySelector( `.autoship-manager .product-card[ data-sid="${ info.sid }" ]` );
					if ( aMProductCard && currQty > newQty )
					{
						handleAutoshipManagerQU( aMProductCard, newQty, "minus" );
					}
					else if ( aMProductCard )
					{
						handleAutoshipManagerQU( aMProductCard, newQty, "plus" );
					}
					currQty = newQty;
					clearFinishedRequests( "sid", info.sid );
				}
				else
				{
					currQty = newQty;
					handleModalQU( newestRequest.quantity );
				}
			}
		});
	}

  modal.querySelector('.autoship-modal__qty-plus').onclick = function () 
  {
    let q = parseInt(qtyInput.value, 10);
		window.autoshipQuantityUpdates.push( { sid: info.sid, quantity: q + 1 } );
		qtyInput.value = q + 1;

		if ( !requestInProgress )
		{
			requestInProgress = true;
			handleModalQU( q + 1 );
		}
  };

  function scheduleQtyUpdate(newQty) 
  {
    clearTimeout(debounceQtyTimer);
    debounceQtyTimer = setTimeout(() => 
    {
      window.ReallyModifySubscriptionQuantity(info.sid, newQty, (err) => 
      {
        if (!err) 
        {
          updatePLPCardQuantity(product.id, variant.id, newQty);
        }
      });
    }, DEBOUNCE_DELAY);
  }

  modal.querySelector('.autoship-modal__remove').onclick = function (e) {
    e.preventDefault();
    if (!confirm('Remove this item from Autoship?')) return;

    let removedAny = false;
    function maybeClose() 
    {
      if (removedAny) 
      {
        alert('Product removed from Autoship.');

        modal.classList.add('hidden');
        document.querySelector('.autoship-overlay')?.classList.add('hidden');
        qtyInput.value = 0;

        const card = document.querySelector(`.product-grid__product-card[data-product-id="${product.id}"][data-variant-id="${variant.id}"]`);
        if (card) {
          const qtyEl = card.querySelector('.pdp-autoship-qty');
          if (qtyEl) qtyEl.classList.add( 'hidden' );

          let autoshipBtn = card.querySelector('.autoship-add-to-cart');

          if (!autoshipBtn) 
          {
            autoshipBtn = document.createElement('button');
            autoshipBtn.className = 'autoship-add-to-cart';
            autoshipBtn.setAttribute('type', 'button');

            autoshipBtn.innerHTML = `
              <span class="autoship-add-to">
                Add to <img src="//welleasy.co.uk/cdn/shop/files/black-autoship-icon.png?v=1741615573&width=20">
                <span class="autoship-name">Autoship</span>
              </span>
            `;

            autoshipBtn.dataset.productId       = product.id;
            autoshipBtn.dataset.variantId       = variant.id;
            autoshipBtn.dataset.productTitle    = product.title;
            autoshipBtn.dataset.productVendor   = product.vendor;
            autoshipBtn.dataset.productImage    = product.featured_image || product.image || '';
            autoshipBtn.dataset.productPrice    = variant.price;
            autoshipBtn.dataset.compareAtPrice  = variant.compare_at_price;

            autoshipBtn.addEventListener('click', function (e) 
            {
              e.preventDefault();
              handleAutoshipAdd(e.currentTarget);
            });

            const target = card.querySelector('.product-card__lower') || card;
            target.appendChild(autoshipBtn);
          }

          autoshipBtn.classList.remove('hidden');
          autoshipBtn.removeAttribute( "disabled" );
        }

      } else {
        alert('Nothing to remove for this product.');
      }
    }


    if (info.sid) {
      removedAny = true;
      window.ReallyModifySubscriptionQuantity(info.sid, 0, (err, response) => {
        if (err) {
          alert('Could not remove subscription: ' + (err.error || err));
        } else if (info.onetimeId) {
          window.ReallyModifyOnetimeQuantityCancel(info.onetimeId, 0, (err2) => {
            if (err2) alert('Could not remove one-time: ' + (err2.error || err2));
            maybeClose();
          });
        } else {
          window._autoshipData = response;
          maybeClose();
          var aMProductCard = document.querySelector( `.autoship-manager .product-card[ data-sid="${ info.sid }" ]` );
          if ( aMProductCard ) handleAutoshipManagerQU( aMProductCard, 0, "minus" );
        }
      });
    } else if (info.onetimeId) {
      removedAny = true;
      window.ReallyModifyOnetimeQuantityCancel(info.onetimeId, 0, (err2) => {
        if (err2) {
          alert('Could not remove one-time: ' + (err2.error || err2));
        } else {
          maybeClose();
        }
      });
    } else {
      maybeClose();
    }
  };

  // Add Once to Next Delivery
  modal.querySelector('.autoship-modal__add-once').onclick = function (e) {
    e.preventDefault();
    const addedEl      = modal.querySelector('.autoship-modal__added');
    const repeatDescEl = modal.querySelector('.autoship-modal__repeat-desc');
    function setOnetimeText() {
      const strongEl = modal.querySelector('.autoship-modal__add-once strong');
      if (strongEl) strongEl.textContent = 'Switch to recurring';
      if (addedEl)   addedEl.textContent = 'This item will be delivered once with your next Autoship order';
      if (repeatDescEl) repeatDescEl.innerHTML = 'It won’t repeat unless you add it again.<span class="autoship-modal__repeat-interval"></span>';
    }

    function refreshAutoshipData( )
    {
        FetchNextAutoshipOrder( function( err, rechargeData )
        {
            if ( err )
            {
                console.log( err )
            }
            else
            {
                PopulateAutoshipDetails( rechargeData );
            }
        });
    }

    if (info.sid) {
      window.ReallyModifySubscriptionQuantity(info.sid, 0, (err) => {
        if (!err) {
          window.ReallyModifyOnetimeQuantity(info.aid, 1, product.id, variant.id, (err2) => {
            if (!err2) {
              setOnetimeText();
              refreshAutoshipData();
              const card = document.querySelector(`.product-grid__product-card[data-product-id="${product.id}"][data-variant-id="${variant.id}"]`);
              if ( card )
              {
                card.querySelector( ".autoship-add-to-cart" ).removeAttribute( "disabled" );
                card.querySelector( ".autoship-add-to-cart" ).classList.remove( "hidden" );
                card.querySelector( ".pdp-autoship-qty" ).classList.add( "hidden" );
              }
              alert('Moved to one-time for your next delivery!');
            } else {
              alert('Could not add as one-time: ' + (err2.error || err2));
            }
          });
        } else {
          alert('Could not remove subscription: ' + (err.error || err));
        }
      });
    } else {
      window.ReallyModifyOnetimeQuantity(info.aid, 1, product.id, variant.id, (err2) => {
        if (!err2) {
          setOnetimeText();
          refreshAutoshipData();
          const card = document.querySelector(`.product-grid__product-card[data-product-id="${product.id}"][data-variant-id="${variant.id}"]`);
          if ( card )
          {
            card.querySelector( ".autoship-add-to-cart" ).removeAttribute( "disabled" );
            card.querySelector( ".autoship-add-to-cart" ).classList.remove( "hidden" );
            card.querySelector( ".pdp-autoship-qty" ).classList.add( "hidden" );
          }
          alert('Added as one-time to your next delivery!');
        } else {
          alert('Could not add as one-time: ' + (err2.error || err2));
        }
      });
    }
  };
}

// Utility - date formatter
function formatDate(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}
